import { render, staticRenderFns } from "./ELoader.vue?vue&type=template&id=bbdbd814"
import script from "./ELoader.vue?vue&type=script&lang=js"
export * from "./ELoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports